import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { SystemStatus } from "@/components/SystemStatus";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { LangCurrencySwitcher } from "@/components/LangCurrencySwitcher";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/markets", key: "nav.markets" },
  { to: "/signals", key: "nav.signals" },
  { to: "/ai-analyst", key: "nav.aiAnalyst" },
  { to: "/paper-trading", key: "nav.paperTrading" },
  { to: "/backtesting", key: "nav.backtesting" },
  { to: "/academy", key: "nav.academy" },
  { to: "/pricing", key: "nav.pricing" },
];

export function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 border-b border-border glass">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <div className="flex items-center gap-6">
          <Logo />
          <nav className="hidden items-center gap-1 lg:flex">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`}
                className={({ isActive }) => `rounded-lg px-3 py-2 text-sm font-medium transition-colors ${isActive ? "text-foreground bg-secondary" : "text-muted-foreground hover:text-foreground"}`}>
                {t(l.key)}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-2">
          <div className="hidden md:block"><SystemStatus inline /></div>
          <div className="hidden md:block"><LangCurrencySwitcher compact /></div>
          <ThemeToggle />
          {user ? (
            <button data-testid="nav-dashboard-btn" onClick={() => nav("/app")} className="rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90">
              {t("nav.dashboard")}
            </button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="hidden sm:block rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground">{t("nav.login")}</Link>
              <Link to="/register" data-testid="nav-register" className="rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90">{t("nav.startFree")}</Link>
            </>
          )}
          <button className="lg:hidden h-9 w-9 flex items-center justify-center" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-border bg-card lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col p-4">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-medium text-muted-foreground hover:bg-secondary hover:text-foreground">
                {t(l.key)}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
